<template>
  <v-container fill-height fluid>
    <v-snackbar top v-model="snackbar" color="success" :timeout="4000">Your password has been reset!</v-snackbar>
    <v-snackbar top v-model="snackbarFail" color="error" :timeout="4000">{{ failedMessage }}</v-snackbar>
    <v-row align="center" justify="center" v-if="!isVerified && doneLoading">
      <v-col cols="12">
        <v-card flat>
          <p class="text-center title">
            Password reset link is invalid or has expired. Please request a new link
            <router-link to="/forgotpassword">
              <span class="primary--text">here</span>
            </router-link>
          </p>
        </v-card>
      </v-col>
    </v-row>
    <v-row align-md="center" justify-md="center" v-if="isVerified && doneLoading">
      <v-col cols="12" md="4">
        <v-card flat>
          <v-card-title>Reset Password</v-card-title>

          <v-card-text>
            <ValidationObserver ref="observer">
              <v-form ref="form" v-on:submit.prevent>
                <ValidationProvider
                  name="Password"
                  rules="required|min:8|max:64"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    v-on:keyup.enter="submit"
                    label="Password"
                    v-model="newPassword"
                    prepend-icon="mdi-lock"
                    :error-messages="errors"
                    :append-icon="passwordToggle ? 'mdi-eye-off' : 'mdi-eye'"
                    @click:append="() => (passwordToggle = !passwordToggle)"
                    :type="passwordToggle ? 'password' : 'text'"
                  ></v-text-field>
                </ValidationProvider>

                <p class="red--text" ref="error"></p>
                <v-btn class="secondary mt-1 mb-5" @click="submit" :loading="loading">
                  <span>Change Password</span>
                </v-btn>
              </v-form>
            </ValidationObserver>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { auth } from "@/firebase";
import { required, max, min } from "vee-validate/dist/rules";
import {
  extend,
  ValidationProvider,
  ValidationObserver,
  setInteractionMode
} from "vee-validate";
setInteractionMode("passive");
extend("required", {
  ...required,
  message: "{_field_} cannot be empty"
});
extend("max", {
  ...max,
  message: "{_field_} must not be more than {length} characters"
});

extend("min", {
  ...min,
  message: "{_field_} must not be less than {length} characters"
});

export default {
  props: {
    actionCode: String
  },
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      doneLoading: false,
      snackbar: false,
      snackbarFail: false,
      passwordToggle: true,
      email: "",
      isVerified: true,
      newPassword: "",
      failedMessage: "",
      loading: false //submit button
    };
  },
  methods: {
    submit() {
      this.$refs.observer.validate().then(success => {
        if (success) {
          this.loading = true;
          auth
            .confirmPasswordReset(this.actionCode, this.newPassword)
            .then(()=> {
              this.snackbar = true;
              this.loading = false;
            })
            .catch(error => {
              this.$refs.error.innerHTML = error.toString();
              this.failedMessage = error.toString();
              this.snackbarFail = true;
              this.loading = false;
            });
        } else {
          this.failedMessage = 'Invalid new password entered';
          this.snackbarFail = true;
        }
      });
    }
  },
  created() {
    auth.signOut(); //sign out of any existing accounts they are logged in to
    auth
      .verifyPasswordResetCode(this.actionCode)
      .then(email => {
        this.email = email;
        this.isVerified = true;
        this.doneLoading = true;
      })
      .catch(() => {
        //code invalid or has expired
        this.isVerified = false;
        this.doneLoading = true;
      });
  }
};
</script>


<style scoped>
@media only screen and (min-width: 768px) {
  .center {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 30%;
  }
}
</style>
